import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryMultipleDuration extends TitleBase {
	private durationValue: string;

	protected canHandle(): boolean {
		this.durationValue = this.getFilterValue(ParameterType.DURATION);

		return (
			this.indexableFilters.length === 1 &&
			this.multiValueFilters.length >= 1 &&
			this.indexableFilters.some((_) => _.type === ParameterType.DURATION) &&
			this.multiValueFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected getPageTitle(): string {
		return `${this.durationValue} ${this.titlePortalType} in selected countries`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.durationValue} ${this.titlePortalType}`, ' in selected countries');
	}
}
